module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div id=\'utility-costs-container\'></div>\n';

}
return __p
}